/**
 * Browser-side W3C traceparent minting. Mirrors apps/api's TraceContext
 * format so `api`-side logs and portal logs join on the same trace_id.
 *
 *   00-<trace-id 32 hex>-<span-id 16 hex>-01
 *
 * Sampled (flags=01) so the API emits telemetry for portal-originated
 * requests.
 */
function randomHex(bytes: number): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function mintTraceparent(): string {
  return `00-${randomHex(16)}-${randomHex(8)}-01`;
}
